import { Component, Input, OnInit } from '@angular/core';
import { ParkingService } from '@shared/services/layer-service/parking-service/parking.service';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IModalStreetParkingModel } from '@types-custom/models/ui/modal-street-parking-model';

@Component({
  selector: 'cdm-manizales-modal-street-parking',
  templateUrl: './modal-street-parking.component.html',
  styleUrls: ['./modal-street-parking.component.scss'],
})
export class ModalStreetParkingComponent implements OnInit {
  @Input() properties: IModalStreetParkingModel | undefined;
  Icon = Icon;
  timeDuration = '';
  occupationLines = {
    spotAvailable: 0,
    spotOccupied: 0,
    totalSpots: 0
  };
  constructor(public serviceParking:ParkingService){}

  ngOnInit(): void {
    this.formatDuration();
    this.serviceParking.getLineOcupaiyty(this.properties.id).subscribe({
      next:(response:any)=>{
        this.occupationLines = response
      }
      }
    )
  }

  formatDuration(): void {

    if (this.properties.maximumParkingDuration) {
      const regex = /PT(\d+H)?(\d+M)?/;
      const matches = this.properties.maximumParkingDuration.match(regex);

      let hours = 0;
      let minutes = 0;

      if (matches) {
        if (matches[1]) {
            hours = parseInt(matches[1].slice(0, -1), 10);
        }

        if (matches[2]) {
            minutes = parseInt(matches[2].slice(0, -1), 10);
        }
      }

      if (hours > 0 && minutes > 0) {
        this.timeDuration = `
        <span class="text-size-32 text-weight-600">${hours} </span>
        <span class="text-size-24 text-weight-600">horas y </span>
        <span class="text-size-32 text-weight-600">${minutes} </span>
        <span class="text-size-24 text-weight-600">minutos</span>
        `;
      } else if (hours > 0) {
          this.timeDuration = `
          <span class="text-size-32 text-weight-600">${hours} </span>
          <span class="text-size-24 text-weight-600">horas</span>
          `;
      } else {
          this.timeDuration = `
          <span class="text-size-32 text-weight-600">${minutes} </span>
          <span class="text-size-24 text-weight-600">minutos</span>
          `;
      }
    }


  }

}
